import {Typography, Skeleton, Box, Stack} from "@mui/material"
import {ThoughtPieceAuthorDateProps} from "./types"
import {FC} from "react"
import EllipsisTypography from "../../atoms/customTypography/EllipsisTypography"
import {TruncatedTooltip} from "../../atoms/Tooltip"

const ThoughtPieceAuthorDate: FC<ThoughtPieceAuthorDateProps> = (props) => {
  const {author, date, separator, styles, isLoading} = props

  return (
    <>
      {!isLoading ? (
        <Stack direction={"row"} spacing={1}>
          {author.length > 0 && (
            <>
              <Typography component={"div"} sx={styles} align="left">
                <EllipsisTypography
                  text={author}
                  lines={1}
                  fontSize={12}
                  tooltipComponent={TruncatedTooltip}
                />
              </Typography>
              <Typography
                component={"div"}
                minWidth={"fit-content"}
                sx={styles}
                justifyContent={"center"}
                display={"flex"}
                alignContent={"center"}
              >
                <span style={{fontSize: "11px"}}>{`${separator}`}</span>
              </Typography>
            </>
          )}
          <Typography
            component={"div"}
            minWidth={"fit-content"}
            sx={styles}
            align="left"
            noWrap
          >
            <p style={{fontSize: "12px"}}>{date}</p>
          </Typography>
        </Stack>
      ) : (
        <Stack direction="row" spacing={2}>
          <Box>
            <Skeleton animation="wave" variant="text" width={100} height={26} />
          </Box>
          <Box
            sx={{
              display: "flex",
            }}
          >
            <span style={{color: "#242d35", fontSize: "15px"}}>|</span>
            <Skeleton animation="wave" variant="text" width={100} height={26} />
          </Box>
        </Stack>
      )}
    </>
  )
}

export default ThoughtPieceAuthorDate
